module.exports = __webpack_public_path__ + "img/bloqueado.1de52f77.svg";